<template>
  <div class="c-simple-accordion" :id="[modalId + '_simple-accordion_']">
      <button v-b-toggle="modalId" class="btn btn-link-plain" :class="[icon]">
        <!-- //btn--select -->
          <div v-html="title"></div>
      </button>
      <b-collapse :id="modalId" :visible="false">
          <slot>
              
          </slot>
      </b-collapse>
  </div>
</template>

<script>
import uniqid from 'uniqid';
export default {
    props: {
        title: { type: String },
        variant: { 
            type: String, 
            default: 'btn--select'
        }

    },
    data() {
        return {
            modalId: uniqid() + '__phd_accordion_',
            
        }
    },
    computed: {
        icon() {
            if (this.variant === '' || this.variant === 'default') {
                return 'btn--select';
            } if (this.variant === 'phd-community') {
                return 'btn--select phd-community';
            } else {
                return this.variant;
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/app/components/simple-accordion.vue